import { gql } from "@apollo/client";
import classNames from "classnames";
import { client } from "../../lib/apollo";
import { termsOfServicePageQuery } from "../../lib/queries/termsOfServicePage";
import { useDarkModeContext } from "../../src/context/DarkModeContext";
import styles from "./index.module.scss";

const TermsOfService = ({ data }: { data: any }) => {
  const { darkMode } = useDarkModeContext();
  const title = data.data.pages?.nodes[0].title;
  const content = data.data.pages?.nodes[0].content;
  return (
    <div className={classNames(styles.container)}>
      <div className={classNames(styles.wrapper, darkMode && styles.hasDarkMode)}>
        <h1 className={classNames(styles.title)}>{title}</h1>
      </div>
      <div className={classNames(styles.content)} dangerouslySetInnerHTML={{ __html: content }}></div>
    </div>
  );
};
export async function getStaticProps() {
  const termsOfService = await client.query({
    query: gql`
      ${termsOfServicePageQuery}
    `,
  });

  return {
    props: { data: termsOfService },
  };
}
export default TermsOfService;
